import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { ReactNode } from 'react';

import * as pageTitleStyles from './PageTitle.styles';

export interface PageTitleProps {
  children?: ReactNode;
}

function PageTitle({ children }: PageTitleProps) {
  const { classes: textTitle } = pageTitleStyles.usePageTitleStyles();

  return (
    <Box mb={0.5}>
      <Typography variant="h4" component="h1" classes={textTitle}>
        {children}
      </Typography>
    </Box>
  );
}

export default PageTitle;
